<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view :key="$route.fullPath" class="router-view" />
    </keep-alive> -->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="router-view"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" class="router-view"></router-view>
  </div>
</template>

<script>
import VConsole from 'vconsole';
export default {
  name: 'App',
  data() {
    return {
      vConsole: null
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    if (process.env.VERSION == 'test' || process.env.VERSION == 'development') {

      const vConsole = new VConsole();

    }
  },
  mounted() {
    window.document.documentElement.setAttribute('data-theme', 'zhijie')









  }
}
</script>

<style lang="stylus">
  @import './style/skin.stylus'
  @import './style/common.stylus'
  html,body,#app{
    height: 100%;
  }
  #app {
    background-color: #F7F8FA;
    color:#333;
  }

  body #app {
    background-color: #fff;

  }

  body::-webkit-scrollbar {
    display: none;
  }

  .van-nav-bar {
    min-height: 50px;
    padding-top: 40px;
    z-index: 3;

    .van-nav-bar__title {
      font-size: 16px;
      line-height: 22px;
    }
  }
  .router-view {
    background: white;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue